import {createApp} from 'vue';
import useAuth from '@/providers/auth';
import App from '@/App.vue'
import router from "@/router";
import filters from "@/filters/filters";
import {rules} from '@/providers/rules';
import 'intl-tel-input/build/css/intlTelInput.css';
import '@/assets/css/global.css';
import HighchartsVue from 'highcharts-vue';
import Highcharts from 'highcharts';
// import es from 'highcharts/i18n/';

import Maska from "maska";
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'

const {authCheck} = useAuth();

const app = createApp(App).use(Quasar, quasarUserOptions);

//Filters
app.config.globalProperties.$filters = filters;
app.config.globalProperties.$rules = rules;

//Auth
authCheck().then(() => {
    app.use(router);
    return router.isReady();
});
//Mascaras
app.use(Maska);

//Graficas
// app.use(HighchartsVue)

// Highcharts.setOptions({
//     lang: {
//         locale: 'es'
//     }
// });

Highcharts.setOptions({
    lang: {
        locale: "es-MX",
        resetZoom: "Restablecer zoom",
        resetZoomTitle: "Restablecer nivel de zoom 1:1",
        viewFullscreen: "Ver pantalla completa",
        printChart: "Imprimir gráfico",
        downloadPNG: "Descargar PNG",
        downloadJPEG: "Descargar JPEG",
        downloadPDF: "Descargar PDF",
        downloadSVG: "Descargar SVG",
        downloadCSV: "Descargar CSV",
        downloadXLS: "Descargar XLS",
        exitFullscreen: "Salir de pantalla completa",
        loading: "Cargando…",
        noData: "No hay datos para mostrar",
        // decimalPoint: '.',
        // thousandsSep: ',',
    }
});

app.use(HighchartsVue, {
    highcharts: Highcharts
});

//Mount
router.isReady().then(() => {
    app.mount('#app');
});